// useSelectableData.ts
import { useState, useEffect } from 'react';
import { fetchProducts4manual, fetchUsers4manual } from '../utils/api';
import { Product, User } from '../utils/types';

export const useSelectableData = ({
  fetchItems,
  defaultType = 'item',
}: {
  fetchItems: (type: string) => Promise<any[]>;
  defaultType?: string;
}) => {
  const [type, setType] = useState(defaultType);
  const [uuid, setUuid] = useState('');
  const [items, setItems] = useState<any[]>([]);
  const [filteredItems, setFilteredItems] = useState<any[]>([]);
  const [searchQuery, setSearchQuery] = useState('');

  useEffect(() => {
    const load = async () => {
      const res = await fetchItems(type);
      setItems(res);
      setFilteredItems(res);
    };
    load();
  }, [type]);

  const setSearch = (query: string) => {
    setSearchQuery(query);
    const lower = query.toLowerCase();
    const filtered = items.filter(item =>
      (item.product_name || item.name || '').toLowerCase().includes(lower) ||
      (item.product_uuid || item.user_uuid || '').includes(lower)
    );
    setFilteredItems(filtered);
  };

  return {
    type,
    setType,
    uuid,
    setUuid,
    items,
    filteredItems,
    setSearch,
    searchQuery,
  };
};
